<template>
  <v-card>
    <v-card>
      <v-card-actions class="overflow-hidden mr-3">
        <v-row dense align="center" justify="end">
          <v-col cols="auto">
            <v-btn
              outlined
              color="light-blue"
              dark
              @click="printPatientInformation"
              :loading="printLoading"
            >
              Imprimir
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col>
            <v-textarea v-model="observation" dense outlined />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import SAVE_PATIENT_INFORMATION from "@/graphql/patient_information/save_patient_information.gql";

export default {
  name: "PatientInformation",
  props: {
    attendance: Object,
  },
  data() {
    return {
      printLoading: false,
      observation: "",
      showDialog: false,
    };
  },
  created() {
    this.savePatientInformation();
    this.refreshPatientInformation();
  },
  apollo: {
    patientInformation: {
      query: require("@/graphql/patient_information/patient_information.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
      result({ data }) {
        this.observation = data.patientInformation?.observation;
        this.patientInformationId = data.patientInformation?.id;
      },
    },
  },
  methods: {
    async refreshPatientInformation() {
      await this.$apollo.queries.patientInformation.refetch();
    },
    async printPatientInformation() {
      await this.savePatientInformation();
      await this.refreshPatientInformation();
      await this.downloadPatientInformation();
    },
    async savePatientInformation() {
      const { data } = await this.apolloMutate({
        mutation: SAVE_PATIENT_INFORMATION,
        variables: {
          attendanceId: this.attendance.id,
          patientInformationId: this.patientInformationId,
          observation: this.observation,
        },
      })

      this.patientInformationId = data.savePatientInformation.id;
    },
    async generatePreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.patientInformation.lastEsign.id,
          dynamicForm: true,
          examAppraisal: true,
        },
      });
    },
    async openPdfInNewTab(url) {
      await window.open(`${process.env.VUE_APP_BASE_URL}${url}`, "_blank");
    },
    async downloadPatientInformation() {
      this.printLoading = true;
      await this.generatePreview();
      await this.refreshPatientInformation();
      //await this.$store.dispatch("authentication/refreshToken");
      const pdfUrl = this.patientInformation.lastEsign.fileUrl;

      await this.openPdfInNewTab(pdfUrl);

      this.printLoading = false;
    },
  },
};
</script>
